import { CommonBaseData } from "../shared/data/common-base-data";

export class N4074MainData extends CommonBaseData {
  // グループ区分
  public gurupuKubun: string;
  // グループ区分名
  public gurupuKubunMei: string;

  // チェックボックス
  public flg: boolean;
}



// WEBPACK FOOTER //
// ./src/app/modules/n407/n4074-main-data.ts